
import "core-js/stable";
import "regenerator-runtime/runtime";
import { ConfigProvider } from '@alifd/next';
import { setComponentResolve } from '@alife/gov-render-sdk/es/engine/remote/remote-component.config';
import PageLoading from '@recept-pc-sdk/component/PageLoading';
import '@recept-pc-sdk/extensions/entryGlobal';
import { createApp } from 'ice';
import * as React from 'react';
import './global.scss';

// 为扩展模块注册公共依赖排包
setComponentResolve({
  react: require('react'),
  'react-dom': require('react-dom'),
  '@alifd/next': require('@alifd/next'),
});

const appConfig = {
  app: {
    rootId: 'recept-root',
    parseSearchParams: true,
    addProvider: ({ children }) => {
      return <ConfigProvider>{children}</ConfigProvider>;
    },
  },
  router: {
    type: 'hash',
    fallback: <PageLoading />,
  },
};

createApp(appConfig);

  